/** Bumped automatically before each production frontend deploy. */
export const APP_VERSION = '0.1.116';
